var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"name-wrapper",attrs:{"to":{name: 'ViewContractor', params: {id: _vm.contractor.id}}}},[_c('UserAvatar',{attrs:{"user":_vm.contractor.user}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }